module.exports = __webpack_public_path__ + "static/media/top_shape_7.a8887785.svg";